import type {
  TFooterNavigationSection,
} from "@/ui/components/navigation/Footer";
import { PublicConfig } from "apps/website/config/public";
import { routes } from "apps/website/utils/routes";

const SIGN_UP_HREF = routes.website.signUp.fresh();
const DEFAULT_DISCOUNT_QUERY = "discount_code=TRY20";
const AC_DISCOUNT_QUERY = "discount_code=MEOWAC30";
const META_DISCOUNT_QUERY = "discount_code=FEAST20";

export type TSignUpFunnelOptions = {
  isFreshFoodNewUserPage?: boolean;
  isFreshFeastTrialPage?: boolean;
  isSignupFlowV2AC?: boolean;
  isFreshFeastTrialACPage?: boolean;
  hasSUFv2CTAs?: boolean;
  isMetaSignUpFunnelPage?: boolean;
  associatedDiscountCode?: string;
};

// The first matching funnel wins when a page sets more than one flag.
// With no funnel, the associated discount (if any) is added to the plain sign-up link.
export function getSignUpFunnelHref({
  isFreshFoodNewUserPage,
  isFreshFeastTrialPage,
  isSignupFlowV2AC,
  isFreshFeastTrialACPage,
  hasSUFv2CTAs,
  isMetaSignUpFunnelPage,
  associatedDiscountCode,
}: TSignUpFunnelOptions): string | null {
  const discountQuery = associatedDiscountCode ?? DEFAULT_DISCOUNT_QUERY;
  const funnels: [boolean | undefined, string][] = [
    [ isFreshFoodNewUserPage, `${SIGN_UP_HREF}?${discountQuery}` ],
    [ isFreshFeastTrialPage, SIGN_UP_HREF ],
    [ isSignupFlowV2AC, `${SIGN_UP_HREF}?${AC_DISCOUNT_QUERY}` ],
    [ isFreshFeastTrialACPage, `${SIGN_UP_HREF}?${AC_DISCOUNT_QUERY}` ],
    [ hasSUFv2CTAs, `${SIGN_UP_HREF}?${discountQuery}` ],
    [
      isMetaSignUpFunnelPage,
      `${PublicConfig.NEXT_PUBLIC_WEBSITE_URL}${SIGN_UP_HREF}?${META_DISCOUNT_QUERY}`,
    ],
  ];
  const activeFunnel = funnels.find(([ isActive ]) => isActive);

  if (activeFunnel) {
    return activeFunnel[1];
  }
  return associatedDiscountCode ? `${SIGN_UP_HREF}?${associatedDiscountCode}` : null;
}

export function applySignUpFunnelLinks(
  sections: TFooterNavigationSection[],
  signUpHref: string | null | undefined,
): TFooterNavigationSection[] {
  if (!signUpHref) {
    return sections;
  }

  return sections.map((section) => ({
    ...section,
    links: section.links.map((link) => (
      link.href === SIGN_UP_HREF ? { ...link, href: signUpHref } : link
    )),
  }));
}
